import React, {useState, useEffect} from 'react';
import "./Pricing.css";

import { useNavigate } from 'react-router-dom';
import {loadStripe} from '@stripe/stripe-js';
import * as Loader from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import MapItButton from '../../Common/MapItButton/MapItButton';
import * as Network from '../../Network/Network';
import PageTitle from '../../Common/PageTitle/PageTitle'; // Adjust the path as per your file structure
import {Helmet} from "react-helmet";

const Pricing = ({user, setUser, subPlan, setSubPlan, setRegMode}) => {
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

//   const stripeProductKey = "pk_test_51P7G7WAAPuhdwRL35ymriOpqNPcTQy2S8cW7jxv4dVY1lgHBnatmUk3a9RgvQcQ5Z5xIbzB8Lf6VajWl6NGNE5ZQ00QQG5q47y";
  const stripeProductKey = "pk_live_51P7G7WAAPuhdwRL3ItOHsgW1Ds2UmF7bYPmECSg1tg125aqxvrweluh30wcmAfUaoHQ2HsefcdkndXb1oYBTeKXF00qmntGvir";

  useEffect(() => {
    if (user && Object.keys(user).length != 0) {
      updateUserObj();
    }
  }, [])

  const updateUserObj = () => {
    setLoading(true);
    Network.getUserSub(user.email, function (err, result) {
        if (err) {
            console.log(err);
            console.log("user obj did not get updated");
            setLoading(false);
        } else {
            // update user object
            if (user.sub_plan !== result.sub_plan) {
            setUser({...user, sub_plan: result.sub_plan, sub_cancel_pending: ""});
            } else {
            console.log(`no update occurred`);
            }
            setLoading(false);
        }
    });
  }

  const changePlan = (plan_type) => {
    console.log(`in change plan`);
    if (user.sub_plan > plan_type) {
        //downgrade
        // should be a popup here confirming users decision
        setLoading(true);
        Network.cancelSub (user.email, function (err, result) {
            if (err) {
                console.log("error during downgrade");
                console.log(err);
                setLoading(false);
            } else {
                setLoading(false);
                console.log(result);
                toast.success(`Subscription will be canceled on ${result.substring(0,10)}`);
                setUser({...user, sub_cancel_pending: result.substring(0,10)});   
            }
        })
    } else {
        // upgrade
        // should be some sort of pop up here validing the user wants to subscribe - todo
        setLoading(true);
        Network.stripeCheckoutSession (user.email, plan_type, {}, "", async function (err, session) {
            if (err) {
                console.log("error during sub upgrade");
                console.log(err);
                setLoading(false);
            } else {
                const stripe = await loadStripe(stripeProductKey);
                if(session && session.id) {
                    const result = stripe.redirectToCheckout ({
                        sessionId: session.id
                    });
                }
                setLoading(false);
            }
        });
    }
  }

  const downgradePlan = () => {

  }

  const resubscribe = () => {
    console.log("User is resubscribing");
    setLoading(true);
    Network.resubscribe(user.email, function (err, result) {
        if (err) {
            console.log("error during sub upgrade");
            console.log(err);
            setLoading(false);
        } else {
            setLoading(false);
            console.log("resubscribe successful");
            console.log(result);
            setUser({...user, sub_cancel_pending: ""});
            toast.success("Resubscribed successfully");
        }
    })
  }

  const onGetStarted = (plan_type) => {
    setSubPlan(plan_type);
    console.log(`in onGetStarted`);
    console.log(plan_type);
    if (!user || (user && Object.keys(user).length === 0)) {
        console.log("in first branch")
        switch (plan_type) {
            case 0:
                navigate('/create');
                break;
            case 1:
                setRegMode(true);
                navigate('/login');
                break;
            case 2:
                setRegMode(true);
                navigate('/login');
                break;
        }
    } else {
        if (user.sub_plan === plan_type && user.sub_cancel_pending) {
            resubscribe(plan_type);
        }
        else if (user.sub_plan === plan_type) {
            navigate('/create');
        } else {
            changePlan(plan_type);
        }
    }
  }

  const setTextSingle = () => {
    console.log("In setTextSingle");
    if (user && Object.keys(user).length != 0) {
        console.log(user.sub_plan);
        switch(user.sub_plan) {
            case 0:
                return "Get Started";
                break;
            case 1:
                return "Downgrade";
                break;
            case 2:
                return "Downgrade";
        }
    } else {
        return "Get Started";
    }
  }

  const getTier1SubValue = () => {
    return (user.sub_cancel_pending)?"Resubscribe":"Subscribed";
  }

  const setTextTier1 = () => {
    console.log("In setTextTier1");
    // console.log(user.sub_plan);
    if (user && Object.keys(user).length != 0) {
        switch(user.sub_plan) {
            case 0:
                return "Upgrade";
            case 1:
                return getTier1SubValue();
            case 2:
                return "Downgrade";
        }
    } else {
        return "Get Started";
    }
  }

  const setTextTier2 = () => {
    console.log("In setTextTier1");
    // console.log(user.sub_plan);
    if (user && Object.keys(user).length != 0) {
        switch(user.sub_plan) {
            case 0:
                return "Upgrade";
            case 1:
                return "Upgrade";
            case 2:
                return "Subscribed";
        }
    } else {
        return "Get Started";
    }
    
  }

  return(
    <div className="pricing-grid-outter">
        <PageTitle title="Pricing"/>
        <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://mapit.cc/pricing" />
      </Helmet>
        <div className="pricing-grid-text">
            <p className='team-collab-title'>
            Create Smart Floor Plans
            </p>
            <p className='team-collab-text'>
            Make your listings standout
            </p>
        </div>
        <div className="pricing-grid-inner">
            <div className="pricing-item2">
                <div className="pricing-desc">
                    <p className="pricing-title">Single</p>
                    <p className="price">$9.99/floor plan</p>
                    <p className="pricing-desc-p">Try your first smart floor plan out for free. For low volumes.</p>
                    <MapItButton onSubmit={() => onGetStarted(0)} text={setTextSingle()} className="getStartedButtonPricing"></MapItButton>
                    <hr className="hr"/>
                </div>
                <div className="feature-list">
                    <p>Single floor plan</p>
                    <p>Unlimted property photos</p>
                    <p>Hyperlink and QR code sharing</p>
                    <p>Email support</p>
                </div>
            </div>
            <div className="pricing-item3">
                <div className="pricing-desc">
                    <p className="pricing-title">Professional</p>
                    <p className="price">$14.99/mo</p>
                    <p className="pricing-desc-p">All of the essential features to make your listings the talk of the town</p>
                    <MapItButton onSubmit={() => onGetStarted(1)} text={setTextTier1()} className="getStartedButtonPricing"></MapItButton>
                    <hr className="hr"/>
                </div>
                <div className="feature-list">
                    <p>Unlimited floor plans</p>
                    {/* <p>HTML Embedded sharing</p> */}
                    <p>Phone support</p>
                </div>
            </div>
            {/* <div className="pricing-item3">
                <div className="pricing-desc">
                    <p className="pricing-title">Professional</p>
                    <p className="price">$20/mo</p>
                    <p className="pricing-desc-p">Full video and photo mapping. Advanced features for efficiency.</p>
                    <MapItButton onSubmit={() => onGetStarted(2)} text={setTextTier2()} className="getStartedButtonPricing"></MapItButton>
                    <hr className="hr"/>
                </div>
                <div className="feature-list">
                    <p>Unlimited property videos</p>
                    <p>AI photo and video mapping</p>
                </div>
            </div> */}
            <ToastContainer 
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                theme="light"
            />
            { loading &&
            <Loader.DotLoader
            color="#FCC81A"
            loading={loading}
            cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1}}
            size={48}
            aria-label="Loading Spinner"
            data-testid="loader"
            />
            }
        </div>
    </div>
  );
}

export default Pricing;